import { render } from "./Pages.vue?vue&type=template&id=c66222fe&scoped=true"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=c66222fe&scoped=true&lang=css"

import exportComponent from "/data/local/webspace/artflsrv04/html/philologic4.7/publicdicos/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66222fe"]])

export default __exports__